import { Injectable } from '@angular/core';
import { ApiEndpoints } from './api-endpoints.service';

@Injectable({
  providedIn: 'root',
})
export class LeadService {
  constructor(private apiEndpoint: ApiEndpoints) {}

  /**
   * Get leads of agent
   * @return {Observable}
   */
  getLeads(object) {
    object.term = object.term || '';
    object.order = object.order || '';
    object.sort_by = object.sort_by || '';
    object.likelihood = object.likelihood || '';
    object.city = object.city || '';
    object.state = object.state || '';
    object.gender = object.gender || '';
    object.property_type = object.property_type || '';
    object.financing_type = object.financing_type || '';
    object.marital_status = object.marital_status || '';
    object.budget = object.budget || '';

    return this.apiEndpoint.get('leads', {}, object);
  }
}
